import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (hovered) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[50],
  borderRadius: (p) => p.spacing(0.5),
  background: hovered
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(2, 1),
});

export const avatar: SxStyle = {
  // width: (p) => p.spacing(2),
  // height: (p) => p.spacing(2),
};

export const headquarter: SxStyle = {
  fontSize: (p) => p.typography.body5.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.primary[900],
  background: (p) => p.palette.common.white,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[200],
  borderRadius: (p) => p.spacing(0.5),
  padding: (p) => p.spacing(0, 0.5),
};

export const companyInfo: SxStyle = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
  ml: (p) => p.spacing(3),
};
